import InvoiceCard from './invoiceCard';
import { format } from 'date-fns';
import Label from '../../../../components/label/label';
import Input from '../../../../components/input/input';
import Button from '../../../../components/button/button';
import CustomSelect from '../../../../components/customSelect/customSelect';

export default function AllInvoices({ invoices = [], customers = [], onNavigate, onLoadMore, hasMore, searchName, setSearchName, selectedSort, onSortChange }) {
    const sortOptions = [
        { id: 'date_desc', name: 'Datum absteigend' },
        { id: 'date_asc', name: 'Datum aufsteigend' }
    ];

    const getCustomerFullName = (inv) => {
        if (!inv) return '';
        if (inv.customer && typeof inv.customer === 'object') {
            return `${inv.customer.prename || ''} ${inv.customer.name || ''}`.trim();
        }
        const cust = customers.find(c => c._id === inv.customer);
        return cust ? `${cust.prename || ''} ${cust.name || ''}`.trim() : '';
    };

    return (
        <div className='invoiceSearchContainer'>
            <Label labelFor="customerSearch" labelValue="Kunde suchen:" />
            <Input
                borderColor='black'
                inputId="customerSearch"
                inputName="customerSearch"
                inputType="text"
                placeholder="Namen eingeben"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
            />
            <div className='invoiceSortContainer'>
                <Label labelFor="sortBy" labelValue="Sortieren:" />
                <CustomSelect
                    items={sortOptions}
                    selected={sortOptions.find(o => o.id === selectedSort)}
                    setSelected={onSortChange}
                    placeholder="Sortieren nach"
                    search={false}
                />
            </div>

            <div className='invoiceCardContainer'>
                {invoices.map((invoice, index) => {
                    const total = invoice.items.reduce((sum, item) => sum + (Number(item.totalBrut) || 0), 0);
                    const custName = getCustomerFullName(invoice) || 'Kein Name';
                    const [prename, ...rest] = custName.split(' ');
                    const name = rest.join(' ');

                    return (
                        <InvoiceCard
                            key={invoice._id || index}
                            custPrename={prename ?? 'Kein Vorname'}
                            custName={name ?? 'Kein Name'}
                            createdAt={invoice.createdAt ? format(new Date(invoice.createdAt), 'dd.MM.yyyy') : 'Kein Datum'}
                            total={total.toFixed(2) + ' €'}
                            onclick={() => onNavigate(invoice._id)}
                            paid={invoice.isPaid ? 'Ja' : 'Nein'}
                            invoiceNumber={invoice.invoiceNumber || 'Keine Rechnungsnummer'}
                        />
                    );
                })}
            </div>

            {hasMore && (
                <Button
                    className='containerButton'
                    onClick={onLoadMore}
                    buttonValue='Mehr laden'
                />
            )}
            {!hasMore && invoices.length > 0 && (
                <p>Alle Rechnungen geladen</p>
            )}
        </div>
    );
}